import { render, staticRenderFns } from "./notCloth.vue?vue&type=template&id=56143029"
import script from "./notCloth.vue?vue&type=script&lang=js"
export * from "./notCloth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports